import React from 'react'
// Branding components
const PreviewBranding = () => (
  <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex items-center gap-1.5 z-50">
    <img
      src="https://uploadthingy.s3.us-west-1.amazonaws.com/jye2JUseKq138NFTbuNn4K/logo_landscape.svg"
      alt="filmmakers.io"
      className="h-8"
    />
  </div>
)
const Branding = () => (
  <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-50">
    <img
      src="https://uploadthingy.s3.us-west-1.amazonaws.com/jye2JUseKq138NFTbuNn4K/logo_landscape.svg"
      alt="filmmakers.io"
      className="h-12"
    />
  </div>
)
const CinematicBranding = ({ isStory }: { isStory: boolean }) => (
  <div
    className={`absolute ${isStory ? 'bottom-3' : 'bottom-4'} left-1/2 -translate-x-1/2 flex items-center gap-2 z-50`}
  >
    <img
      src="https://uploadthingy.s3.us-west-1.amazonaws.com/jye2JUseKq138NFTbuNn4K/logo_landscape.svg"
      alt="filmmakers.io"
      className="h-12"
    />
  </div>
)
const SplitScreenBranding = ({ isStory }: { isStory: boolean }) => (
  <div className="absolute top-6 left-6 z-50">
    <img
      src="https://uploadthingy.s3.us-west-1.amazonaws.com/jye2JUseKq138NFTbuNn4K/logo_landscape.svg"
      alt="filmmakers.io"
      className={`${isStory ? 'h-8' : 'h-10'}`}
    />
  </div>
)
interface TemplateRenderProps {
  quote: string
  author: string
  imageUrl: string | null
  aspectClass: string
  textSizeClass: string
  authorSizeClass: string
  isStory: boolean
  hasAuthor: boolean
}
interface FilmmakerTemplate {
  id: string
  name: string
  description: string
  getDefaultImage: () => string
  renderPreview: () => React.ReactElement
  renderPost: (props: TemplateRenderProps) => React.ReactElement
}
export const filmmakersTemplates: FilmmakerTemplate[] = [
  {
    id: 'centered-classic',
    name: 'Centered Classic',
    description: 'Bold centered layout with maximum impact',
    getDefaultImage: (): string =>
      'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=1080&h=1080&fit=crop',
    renderPreview: (): React.ReactElement => (
      <div className="aspect-square w-full rounded-lg overflow-hidden relative bg-[#1A1A1F]">
        <img
          src="https://images.unsplash.com/photo-1485846234645-a62644f84728?w=400&q=80"
          alt="Preview"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/85 to-black/50"></div>
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-8 pb-12">
          <p className="text-white font-['Playfair_Display',serif] text-xl leading-tight mb-4 font-bold tracking-tight">
            "Your inspiring quote here"
          </p>
          <p className="text-[#F26419] text-sm font-['Funnel_Sans',sans-serif] uppercase font-bold tracking-[0.2em]">
            Author Name
          </p>
        </div>
        <PreviewBranding />
      </div>
    ),
    renderPost: ({
      quote,
      author,
      imageUrl,
      aspectClass,
      textSizeClass,
      authorSizeClass,
      isStory,
      hasAuthor,
    }: TemplateRenderProps): React.ReactElement => (
      <div
        className={`${aspectClass} w-full overflow-hidden relative bg-[#0E0E11]`}
      >
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Background"
            className="absolute inset-0 w-full h-full object-cover"
          />
        )}
        {imageUrl && (
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/85 to-black/50"></div>
        )}
        <div
          className={`absolute ${isStory ? 'top-[18%] bottom-[13%]' : 'inset-0 pb-24'} flex flex-col justify-center items-center text-center ${isStory ? 'px-12' : 'px-16'}`}
        >
          <p
            className={`text-white font-['Playfair_Display',serif] ${textSizeClass} leading-[1.3] ${hasAuthor ? 'mb-8' : ''} font-bold tracking-tight`}
          >
            {hasAuthor ? `"${quote}"` : quote}
          </p>
          {hasAuthor && (
            <p
              className={`text-[#F26419] ${authorSizeClass} font-['Funnel_Sans',sans-serif] font-bold uppercase tracking-[0.2em]`}
            >
              {author}
            </p>
          )}
        </div>
        <Branding />
      </div>
    ),
  },
  {
    id: 'split-screen',
    name: 'Split Screen',
    description: 'Dynamic contrast layout',
    getDefaultImage: (): string =>
      'https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=1080&h=1080&fit=crop',
    renderPreview: (): React.ReactElement => (
      <div className="aspect-square w-full rounded-lg overflow-hidden relative bg-[#1A1A1F]">
        <div className="absolute inset-0 flex">
          <div className="w-1/2 relative">
            <img
              src="https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=400&q=80"
              alt="Preview"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/70"></div>
            <div className="absolute top-3 left-3">
              <img
                src="https://uploadthingy.s3.us-west-1.amazonaws.com/jye2JUseKq138NFTbuNn4K/logo_landscape.svg"
                alt="filmmakers.io"
                className="h-6"
              />
            </div>
          </div>
          <div className="w-1/2 bg-[#0E0E11] flex flex-col justify-center px-6 py-8">
            <p className="text-white font-['Playfair_Display',serif] text-lg leading-tight mb-4 font-bold tracking-tight">
              "Your inspiring quote"
            </p>
            <p className="text-[#F26419] text-xs font-['Funnel_Sans',sans-serif] uppercase font-bold tracking-[0.2em]">
              Author
            </p>
          </div>
        </div>
      </div>
    ),
    renderPost: ({
      quote,
      author,
      imageUrl,
      aspectClass,
      textSizeClass,
      authorSizeClass,
      isStory,
      hasAuthor,
    }: TemplateRenderProps): React.ReactElement => {
      const textPadding = isStory ? 'px-10 py-16' : 'px-12 py-16'
      return (
        <div
          className={`${aspectClass} w-full overflow-hidden relative bg-[#0E0E11]`}
        >
          <div className="absolute inset-0 flex">
            <div className="w-1/2 relative">
              {imageUrl && (
                <img
                  src={imageUrl}
                  alt="Background"
                  className="absolute inset-0 w-full h-full object-cover"
                />
              )}
              {imageUrl && <div className="absolute inset-0 bg-black/70"></div>}
              <SplitScreenBranding isStory={isStory} />
            </div>
            <div
              className={`w-1/2 bg-[#0E0E11] flex flex-col justify-center ${textPadding}`}
            >
              <p
                className={`text-white font-['Playfair_Display',serif] ${textSizeClass} leading-[1.35] ${hasAuthor ? 'mb-6' : ''} font-bold tracking-tight`}
              >
                {hasAuthor ? `"${quote}"` : quote}
              </p>
              {hasAuthor && (
                <p
                  className={`text-[#F26419] ${authorSizeClass} font-['Funnel_Sans',sans-serif] font-bold uppercase tracking-[0.2em]`}
                >
                  {author}
                </p>
              )}
            </div>
          </div>
        </div>
      )
    },
  },
  {
    id: 'cinematic-frame',
    name: 'Cinematic Frame',
    description: 'Elegant border frame design',
    getDefaultImage: (): string =>
      'https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=1080&h=1080&fit=crop',
    renderPreview: (): React.ReactElement => (
      <div className="aspect-square w-full rounded-lg overflow-hidden relative bg-[#0E0E11]">
        <img
          src="https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=400&q=80"
          alt="Preview"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/80"></div>
        <div className="absolute inset-5 border-2 border-[#F26419]/40"></div>
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-10 pb-10">
          <p className="text-white font-['Playfair_Display',serif] text-xl leading-tight mb-4 font-bold tracking-tight">
            "Your inspiring quote"
          </p>
          <p className="text-[#F26419] text-sm font-['Funnel_Sans',sans-serif] uppercase font-bold tracking-[0.2em]">
            Author
          </p>
        </div>
        <PreviewBranding />
      </div>
    ),
    renderPost: ({
      quote,
      author,
      imageUrl,
      aspectClass,
      textSizeClass,
      authorSizeClass,
      isStory,
      hasAuthor,
    }: TemplateRenderProps): React.ReactElement => {
      // Dynamic font sizing based on quote length for story format
      let storyTextSize = textSizeClass
      let storyAuthorSize = authorSizeClass
      if (isStory) {
        const quoteLength = quote.length
        if (quoteLength < 100) {
          storyTextSize = 'text-4xl'
          storyAuthorSize = 'text-base'
        } else if (quoteLength < 200) {
          storyTextSize = 'text-2xl'
          storyAuthorSize = 'text-sm'
        } else {
          storyTextSize = 'text-xl'
          storyAuthorSize = 'text-xs'
        }
      }
      return (
        <div
          className={`${aspectClass} w-full overflow-hidden relative bg-[#0E0E11]`}
        >
          {imageUrl && (
            <img
              src={imageUrl}
              alt="Background"
              className="absolute inset-0 w-full h-full object-cover"
            />
          )}
          {imageUrl && <div className="absolute inset-0 bg-black/80"></div>}
          <div
            className={`absolute ${isStory ? 'inset-6' : 'inset-10'} border-[3px] border-[#F26419]/40`}
          ></div>
          <div
            className={`absolute ${isStory ? 'top-[15%] bottom-[15%]' : 'inset-0 pb-20'} flex flex-col justify-center items-center text-center ${isStory ? 'px-14' : 'px-20'}`}
          >
            <p
              className={`text-white font-['Playfair_Display',serif] ${storyTextSize} leading-[1.3] ${hasAuthor ? 'mb-8' : ''} font-bold tracking-tight`}
            >
              {hasAuthor ? `"${quote}"` : quote}
            </p>
            {hasAuthor && (
              <p
                className={`text-[#F26419] ${storyAuthorSize} font-['Funnel_Sans',sans-serif] font-bold uppercase tracking-[0.2em]`}
              >
                {author}
              </p>
            )}
          </div>
          <CinematicBranding isStory={isStory} />
        </div>
      )
    },
  },
  {
    id: 'editorial',
    name: 'Editorial',
    description: 'Magazine-style bold statement',
    getDefaultImage: (): string =>
      'https://images.unsplash.com/photo-1524985069026-dd778a71c7b4?w=1080&h=1080&fit=crop',
    renderPreview: (): React.ReactElement => (
      <div className="aspect-square w-full rounded-lg overflow-hidden relative bg-[#1A1A1F]">
        <img
          src="https://images.unsplash.com/photo-1524985069026-dd778a71c7b4?w=400&q=80"
          alt="Preview"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/95 via-black/80 to-transparent"></div>
        <div className="absolute top-0 left-0 w-20 h-1 bg-[#F26419]"></div>
        <div className="absolute inset-0 flex flex-col justify-start px-6 pt-10 pb-12">
          <p className="text-white font-['Playfair_Display',serif] text-xl leading-tight mb-4 font-bold tracking-tight">
            "Your inspiring quote"
          </p>
          <p className="text-[#F26419] text-xs font-['Funnel_Sans',sans-serif] uppercase font-bold tracking-[0.2em]">
            Author
          </p>
        </div>
        <PreviewBranding />
      </div>
    ),
    renderPost: ({
      quote,
      author,
      imageUrl,
      aspectClass,
      textSizeClass,
      authorSizeClass,
      isStory,
      hasAuthor,
    }: TemplateRenderProps): React.ReactElement => (
      <div
        className={`${aspectClass} w-full overflow-hidden relative bg-[#0E0E11]`}
      >
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Background"
            className="absolute inset-0 w-full h-full object-cover"
          />
        )}
        {imageUrl && (
          <div className="absolute inset-0 bg-gradient-to-br from-black/95 via-black/80 to-transparent"></div>
        )}
        <div
          className={`absolute top-0 left-0 ${isStory ? 'w-24' : 'w-40'} h-1.5 bg-[#F26419]`}
        ></div>
        <div
          className={`absolute ${isStory ? 'top-[20%] bottom-[13%] px-12 pt-4' : 'inset-0 px-12 pt-20 pb-24'} flex flex-col justify-start`}
        >
          <p
            className={`text-white font-['Playfair_Display',serif] ${textSizeClass} leading-[1.3] ${hasAuthor ? 'mb-8' : ''} font-bold tracking-tight`}
          >
            {hasAuthor ? `"${quote}"` : quote}
          </p>
          {hasAuthor && (
            <p
              className={`text-[#F26419] ${authorSizeClass} font-['Funnel_Sans',sans-serif] font-bold uppercase tracking-[0.2em]`}
            >
              {author}
            </p>
          )}
        </div>
        <Branding />
      </div>
    ),
  },
  {
    id: 'minimalist',
    name: 'Minimalist',
    description: 'Clean, powerful simplicity',
    getDefaultImage: (): string =>
      'https://images.unsplash.com/photo-1533158326339-7f3cf2404354?w=1080&h=1080&fit=crop',
    renderPreview: (): React.ReactElement => (
      <div className="aspect-square w-full rounded-lg overflow-hidden relative bg-[#0E0E11]">
        <img
          src="https://images.unsplash.com/photo-1533158326339-7f3cf2404354?w=400&q=80"
          alt="Preview"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/90"></div>
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-8 pb-12 gap-5">
          <div className="flex gap-1.5">
            <div className="w-16 h-0.5 bg-[#F26419]"></div>
            <div className="w-6 h-0.5 bg-[#F26419]/50"></div>
          </div>
          <p className="text-white font-['Playfair_Display',serif] text-xl leading-snug font-bold tracking-tight">
            "Your inspiring quote"
          </p>
          <p className="text-[#F26419] text-xs font-['Funnel_Sans',sans-serif] uppercase tracking-[0.2em] font-bold">
            Author Name
          </p>
        </div>
        <PreviewBranding />
      </div>
    ),
    renderPost: ({
      quote,
      author,
      imageUrl,
      aspectClass,
      textSizeClass,
      authorSizeClass,
      isStory,
      hasAuthor,
    }: TemplateRenderProps): React.ReactElement => (
      <div
        className={`${aspectClass} w-full overflow-hidden relative bg-[#0E0E11]`}
      >
        {imageUrl && (
          <>
            <img
              src={imageUrl}
              alt="Background"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/90"></div>
          </>
        )}
        <div
          className={`absolute ${isStory ? 'top-[18%] bottom-[13%]' : 'inset-0 pb-24'} flex flex-col justify-center items-center text-center ${isStory ? 'px-12' : 'px-16'} gap-10`}
        >
          <div className="flex gap-3">
            <div
              className={`${isStory ? 'w-20' : 'w-32'} h-0.5 bg-[#F26419]`}
            ></div>
            <div
              className={`${isStory ? 'w-8' : 'w-12'} h-0.5 bg-[#F26419]/50`}
            ></div>
          </div>
          <p
            className={`text-white font-['Playfair_Display',serif] ${textSizeClass} leading-[1.4] ${hasAuthor ? 'mb-2' : ''} font-bold tracking-tight max-w-3xl`}
          >
            {hasAuthor ? `"${quote}"` : quote}
          </p>
          {hasAuthor && (
            <p
              className={`text-[#F26419] ${authorSizeClass} font-['Funnel_Sans',sans-serif] font-bold uppercase tracking-[0.2em]`}
            >
              {author}
            </p>
          )}
        </div>
        <Branding />
      </div>
    ),
  },
  {
    id: 'bold-statement',
    name: 'Bold Statement',
    description: 'Maximum visual impact',
    getDefaultImage: (): string =>
      'https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=1080&h=1080&fit=crop',
    renderPreview: (): React.ReactElement => (
      <div className="aspect-square w-full rounded-lg overflow-hidden relative bg-[#0E0E11]">
        <img
          src="https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=400&q=80"
          alt="Preview"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black"></div>
        <div className="absolute left-0 right-0 bottom-0 h-1 bg-gradient-to-r from-transparent via-[#F26419] to-transparent"></div>
        <div className="absolute inset-0 flex flex-col justify-end px-6 pb-14">
          <p className="text-white font-['Playfair_Display',serif] text-xl leading-[1.1] mb-4 font-black uppercase tracking-tighter">
            "BOLD QUOTE"
          </p>
          <p className="text-[#F26419] text-sm font-['Funnel_Sans',sans-serif] uppercase font-black tracking-[0.2em]">
            Author Name
          </p>
        </div>
        <PreviewBranding />
      </div>
    ),
    renderPost: ({
      quote,
      author,
      imageUrl,
      aspectClass,
      textSizeClass,
      authorSizeClass,
      isStory,
      hasAuthor,
    }: TemplateRenderProps): React.ReactElement => {
      const boldTextSize = isStory ? 'text-4xl' : 'text-5xl'
      const boldAuthorSize = isStory ? 'text-lg' : 'text-xl'
      return (
        <div
          className={`${aspectClass} w-full overflow-hidden relative bg-[#0E0E11]`}
        >
          {imageUrl && (
            <img
              src={imageUrl}
              alt="Background"
              className="absolute inset-0 w-full h-full object-cover"
            />
          )}
          {imageUrl && (
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black"></div>
          )}
          <div className="absolute left-0 right-0 bottom-0 h-2 bg-gradient-to-r from-transparent via-[#F26419] to-transparent"></div>
          <div
            className={`absolute inset-0 flex flex-col justify-end ${isStory ? 'px-12 pb-32' : 'px-12 pb-28'}`}
          >
            <p
              className={`text-white font-['Playfair_Display',serif] ${boldTextSize} leading-[1.15] ${hasAuthor ? 'mb-8' : ''} font-black uppercase tracking-tighter`}
            >
              {hasAuthor ? `"${quote}"` : quote}
            </p>
            {hasAuthor && (
              <p
                className={`text-[#F26419] ${boldAuthorSize} font-['Funnel_Sans',sans-serif] font-black uppercase tracking-[0.2em]`}
              >
                {author}
              </p>
            )}
          </div>
          <Branding />
        </div>
      )
    },
  },
]
